module.exports = __webpack_public_path__ + "media/images/home/bookmark-o-488eedf66f48d18bc493239caa9bf3cb.png";